import { gql } from '@apollo/client';

export const GET_SUSPICIOUS_BALANCE_ACTIVITY = gql`
  query getSuspiciousBalanceActivity($lookbackHours: Int, $minCount: Int, $maxAvgGapSeconds: Int, $resource: String) {
    liveOps {
      id
      suspiciousBalanceActivity(
        lookbackHours: $lookbackHours
        minCount: $minCount
        maxAvgGapSeconds: $maxAvgGapSeconds
        resource: $resource
      ) {
        userId
        resource
        source
        count
        totalDelta
        firstAt
        lastAt
        avgGapSeconds
      }
    }
  }
`;

export const GET_USER_BALANCE_CHANGES = gql`
  query getUserBalanceChanges($userId: ID!, $limit: Int) {
    liveOps {
      id
      userBalanceChanges(userId: $userId, limit: $limit) {
        id
        resource
        delta
        balanceAfter
        source
        created
      }
    }
  }
`;
